import { React, useEffect, useState } from 'react';
import {
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  IconButton,
  Avatar,
  Typography,
  Divider,
  Button,
  Box
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import GroupIcon from '@mui/icons-material/Group';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AssignmentIcon from '@mui/icons-material/Assignment';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import AddBoxIcon from '@mui/icons-material/AddBox';
import LogoutIcon from '@mui/icons-material/Logout';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import ChecklistIcon from '@mui/icons-material/Checklist';
import PersonIcon from '@mui/icons-material/Person';

const Sidebar = ({ onLogout, user }) => {
  const [collapsed, setCollapsed] = useState(false);
  const menuItems = [
    { text: 'داشبورد', icon: <DashboardIcon />, path: '/dashboard', roles: ['admin', 'editor'] },
    { text: 'پروفایل', icon: <AccountBoxIcon />, path: '/profile', roles: ['admin', 'editor', 'viewer'] },
    { text: 'مدیریت کاربران', icon: <GroupIcon />, path: '/users', roles: ['admin'] },
    { text: 'پروژه‌ها', icon: <AssignmentIcon />, path: '/projects', roles: ['admin', 'editor'] },
    { text: 'تخصیص کاربران به فرم', icon: <PersonAddAltIcon />, path: '/assign-users', roles: ['admin'] },
    { text: 'بیماران', icon: <PersonIcon />, path: '/subjects', roles: ['admin', 'editor'], requiresCanManageSubjects: true },
    { text: '📥 پاسخ به فرم‌ها', icon: <FormatListBulletedIcon />, path: '/respond-forms', roles: ['viewer'] },
    { text: '📁 فرم‌های من', icon: <ChecklistIcon />, path: '/my-forms', roles: ['viewer'] },
    { text: '🎯 ارزیابی پاسخ‌ها', icon: <FactCheckIcon />, path: '/evaluate-responses', roles: ['admin', 'editor'] },
    { text: 'داشبورد آنالیز', icon: <DashboardIcon />, path: '/dashboardanalytics', roles: ['admin', 'editor'] },
    { text: '📊 مقایسه بیماران', icon: <DashboardIcon />, path: '/reports/form-subject-compare', roles: ['admin', 'editor'] },
  ];

  

  if (!user) return null;
  return (
    <Drawer
      variant="permanent"
      anchor="right"
      sx={{
        width: collapsed ? 60 : 240,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: collapsed ? 60 : 240,
          boxSizing: 'border-box',
          transition: 'width 0.3s'
        }
      }}
    >
      <Box sx={{ p: 2, textAlign: 'center' }}>
        <IconButton onClick={() => setCollapsed(prev => !prev)}>
          {collapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
        </IconButton>

        {/* <Avatar src={user.avatar} sx={{ width: 72, height: 72, margin: '0 auto' }} /> */}
        <Avatar src={user?.avatar || undefined} sx={{ width: 72, height: 72, margin: '0 auto' }} />
        <Typography variant="subtitle1" fontWeight="bold" mt={1}>
          {user?.fullName || 'بدون نام'}
        </Typography>
        <Typography variant="caption">{user?.email || 'بدون ایمیل'}</Typography>
      </Box>

      <Divider />

      <List dir="rtl">
        {menuItems.filter(item => {
            // اول نقش باید بخوره
            const roleOk = item.roles.includes(user.role);

            // اگر آیتم اصلاً شرط اضافه نداشت، همون role کافیه
            if (!item.requiresCanManageSubjects) {
              return roleOk;
            }

            // اگر آیتم شرط اضافه داشت:
            // - ادمین همیشه ببیند
            // - ادیتور فقط اگر canManageSubjects داشته باشد
            if (user.role === 'admin') return true;
            if (user.role === 'editor' && user.canManageSubjects) return true;

            return false;
          }).map((item) => (
          <ListItemButton
            key={item.text}
            component={Link}
            to={item.path}
            sx={{ pl: 2 }}
          >
            <ListItemIcon sx={{ minWidth: 32 }}>{item.icon}</ListItemIcon>
            {!collapsed && <ListItemText primary={item.text} />}
          </ListItemButton>
        ))}
      </List>


      <Box sx={{ mt: 'auto', textAlign: 'center', p: 2 }}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<LogoutIcon />}
          fullWidth
          onClick={onLogout}
        >
          خروج
        </Button>
      </Box>
    </Drawer>
  );
};

export default Sidebar;
